import {useEffect, useState, Fragment} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBell} from "@fortawesome/pro-solid-svg-icons";
import {Nav} from "react-bootstrap";
import {useTypedDispatch, useTypedSelector} from "../app/typedHooks";
import {requestNotifications, requestReadNotifications} from "../features/notifications/data/notificationSlice";
import NotificationsOffCanvas from "./NotificationsOffCanvas";

const Notifications = (): JSX.Element => {
  const dispatch = useTypedDispatch();

  const isLoading = useTypedSelector((state) => state.notification.isLoading);
  const isLoaded = useTypedSelector((state) => state.notification.isLoaded);
  const isError = useTypedSelector((state) => state.notification.isError);

  const totalUnread = useTypedSelector((state) => state.notification.totalUnread);

  const [openPopout, setOpenPopout] = useState(false);

  useEffect(() => {
    if (!isLoading && !isLoaded && !isError) {
      dispatch(requestNotifications());
    }
  }, [dispatch, isLoading, isLoaded, isError]);

  return (
    <Fragment>
      <Nav.Item className="me-2 d-none d-lg-block">
        <Nav.Link
          className="notification-anchor"
          onClick={(e) => {
            e.stopPropagation();
            setOpenPopout(true);
          }}
        >
          <FontAwesomeIcon icon={faBell} />
          {totalUnread > 0 && <span className="notification-alert">{totalUnread}</span>}
        </Nav.Link>
      </Nav.Item>
      <NotificationsOffCanvas
        isOpen={openPopout}
        handleClose={() => {
          setOpenPopout(false);
          dispatch(requestReadNotifications());
        }}
      />
    </Fragment>
  );
};

export default Notifications;
